import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=5d1ce9c9&scoped=true"
import script from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ce9c9",
  null
  
)

export default component.exports